module.exports = __webpack_public_path__ + "static/img/screenshot-auction-box.f93c8c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot-auction-box.png
// module id = z0+C
// module chunks = 1